import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Account',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Account beheren',
      description: 'Houd je account up-to-date en beheer je instellingen.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Betaalmethoden',
      description: 'Voeg toe, wijzig of selecteer je voorkeursbetaalmethode.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Help en veelgestelde vragen',
    },
    [AccountItemEnum.Logout]: {
      title: 'Uitloggen',
    },
    [AccountItemEnum.Language]: {
      title: 'Taal',
    },
  },
};
